import React, { Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DetailsMileageListItem from './ListItems/DetailsMileageListItem';
import CBSelect from '../../shared/CBSelect';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle, getUrlId } from '../../../utils/utils';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import { set } from 'lodash';
import AddMileageButton from './ListItems/AddMileageButton';
import { getReadingUnitLabel } from '../../../utils/equipment';

class VehicleDetailsMileageList extends React.Component {
  state = {
  };

  isSelected = (mileage, idx) => {
    const urlParts = window.location.pathname.split('/');
    const index = urlParts.indexOf('mileages') + 1;

    if (index && urlParts[index]) {
      return mileage.id == urlParts[index];
    }

    return idx == 0;
  };

  mileageSelected = e => {
    const { history, vehicle } = this.props;
    history.push(`/vehicle/${vehicle.id}/mileages/${e.target.value}`);
  };

  //Do not remove. For unknown reasons the view won't re-render without this.
  static getDerivedStateFromProps(nextProps, prevState) {}

  render() {
    const { vehicle, location, history, selectedMileage, selectAllMileage, selectMileage, mileages } = this.props;
    return (
      <CBMediaQuery>
        {screenSize => (
          <div
            style={getStyle(
              screenSize,
              styles,
              screenSize !== 'small' ? 'listContainer' : 'container',
            )}
          >
            {screenSize !== 'small' && (
              <div>
                <div style={getStyle(screenSize, styles, 'addButtonContainer')}>
                  {
                    false && (// Multiselect disabled for now
                      <CBLabelAndCheckbox
                        additionalStyles={{ padding: 8 }}
                        checked={mileages.length === selectedMileage.length}
                        onChange={() => selectAllMileage()}/>
                    )
                  }
                  <AddMileageButton vehicle={vehicle} />
                </div>

                {mileages.map((mileage, idx) => (
                  <DetailsMileageListItem
                    selectMileage={selectMileage}
                    isMultiSelected={selectedMileage.includes(mileage.id)}
                    key={mileage.id}
                    vehicle={vehicle}
                    mileage={mileage}
                    history={history}
                    isSelected={this.isSelected(mileage, idx)}
                  />
                ))}
              </div>
            )}
            {screenSize === 'small' && (
              <Fragment>
                <div>
                  <AddMileageButton vehicle={vehicle} />
                </div>
                <div style={getStyle(screenSize, styles, 'selectContainer')}>
                  <CBSelect
                    value={getUrlId(location.pathname)}
                    onChange={this.mileageSelected}
                    >
                    {mileages.map(mileage => (
                      <option key={mileage.id} value={mileage.id}>
                        {`${moment(mileage.created_at).format('D.M.Y')} | ${
                          mileage.value
                        } ${getReadingUnitLabel(mileage)}`}
                      </option>
                    ))}
                  </CBSelect>
                </div>
              </Fragment>
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
      width: '25%',
    },
    addButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    selectContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 40,
      marginRight: 15,
      marginLeft: 15,
      marginTop: 40,
    },
  },
  small: {
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
      width: '100%',
      overflow: 'auto',
    },
  },
};

function mapStateToProps(state) {
  return {
  };
}

export default connect(
  mapStateToProps,
  {
  },
)(withRouter(VehicleDetailsMileageList));
